/* eslint-disable no-nested-ternary */
import React from 'react';

const Image = ({
  className = '',
  imageSrc = '',
  imageProps = {},
  lazyload = true,
  defaultImgSrc = 'https://storage.googleapis.com/vxrd/default-image-ticket.svg',
  alt = 'default-alt',
}) => (
  <img
    className={`${className} ${lazyload ? 'lazyload' : ''}`}
    data-src={imageSrc}
    src={imageSrc}
    alt={alt}
    {...imageProps}
  />
);

export default Image;
